/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Delete_LabelInputs */



/**
* | output |
* | --- |
* | "Delete selected events" |
*
* @param {Context_Menu_Delete_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_delete_label = /** @type {((inputs?: Context_Menu_Delete_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Delete_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer les evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить выбранные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除选定事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं को हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir eventos selecionados")
	return /** @type {LocalizedString} */ ("Delete selected events")
});